import {
  Authenticated,
  CaseListFilters,
  CoveoEmail,
  CoveoToken,
  FirstRoute,
  Geo,
  HasWorkfront,
  JWT,
  LastRoute,
  Organization,
  Profile,
  ProfileAttributes,
  RecommendedID,
  Region,
  Route,
  SelectedOrg,
  SelectedProduct,
  SolutionLevel,
  SolutionRole,
} from './keys';
import { root } from './page';

export const isLoggedInUser = async () => {
  await window.imsLoaded;
  return window.adobeIMS.isSignedInUser();
};

export const imsSetup = false;

export function signin() {
  localStorage.removeItem(SolutionRole);
  localStorage.removeItem(SolutionLevel);
  sessionStorage.removeItem(CoveoEmail);
  sessionStorage.removeItem(CoveoToken);
  adobeIMS.signIn();
}

export function signout() {
  sessionStorage.removeItem(Geo);
  sessionStorage.removeItem(Region);
  sessionStorage.removeItem(JWT);
  sessionStorage.removeItem(ProfileAttributes);
  sessionStorage.removeItem(Organization);
  sessionStorage.removeItem(Profile);
  sessionStorage.removeItem(FirstRoute);
  sessionStorage.removeItem(LastRoute);
  sessionStorage.removeItem(Authenticated);
  sessionStorage.removeItem(CoveoEmail);
  sessionStorage.removeItem(CoveoToken);
  sessionStorage.removeItem(RecommendedID);
  sessionStorage.removeItem(SelectedOrg);
  sessionStorage.removeItem(HasWorkfront);
  sessionStorage.removeItem(SelectedProduct);
  sessionStorage.removeItem(Route);
  localStorage.removeItem(SolutionRole);
  localStorage.removeItem(SolutionLevel);
  sessionStorage.removeItem(CaseListFilters);

  if (root) {
    location.hash = location.host === 'experienceleague-local.adobe.com' ? 'home' : '';
  }

  adobeIMS.signOut();
}
